import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';

import { useAuthContext } from 'auth/useAuthContext';

export const LoginForm = props => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const { login } = useAuthContext();

  const onLogin = async values => {
    setLoading(true);
    try {
      await login(values.email, values.password);
      setLoading(false);
      navigate('/app/settings/accounts');
    } catch (error) {
      setLoading(false);
      console.error(error);
      message.error('invalid username and password');
    }
  };

  return (
    <>
      <Form layout="vertical" name="login-form" onFinish={onLogin}>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: 'Please input your email'
            },
            {
              type: 'email',
              message: 'Please enter a validate email!'
            }
          ]}
        >
          <Input prefix={<MailOutlined className="text-primary" />} />
        </Form.Item>
        <Form.Item
          name="password"
          label={
            <div
              className={`${'d-flex justify-content-between w-100 align-items-center'}`}
            >
              <span>Password</span>

              <span className="cursor-pointer font-size-sm font-weight-normal text-muted">
                Forget Password?
              </span>
            </div>
          }
          rules={[
            {
              required: true,
              message: 'Please input your password'
            }
          ]}
        >
          <Input.Password prefix={<LockOutlined className="text-primary" />} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

LoginForm.propTypes = {
  otherSignIn: PropTypes.bool,
  showForgetPassword: PropTypes.bool,
  extra: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

LoginForm.defaultProps = {
  otherSignIn: true,
  showForgetPassword: false
};

export default LoginForm;
